import { useState, useEffect } from "react";
import { getFinalPaymentMethods } from "utils";
import { useGetTransactionMethods } from "api/transaction-methods";

const chooserConfig = {
  include: ["wallet"],
};

const useGetPrimaryWallet = ({ currency = "USD" }) => {
  const [wallet, setWallet] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const {
    data,
    isSuccess: isGetTransactionMethodsSuccess,
    ...rest
  } = useGetTransactionMethods({ payout_options: true, bank_accounts: true });

  useEffect(() => {
    if (isGetTransactionMethodsSuccess) {
      const pmsDict = data.payload.payment_methods;
      const paymentMethods = Object.keys(pmsDict).map((k) => pmsDict[k]);
      const wallets = getFinalPaymentMethods(paymentMethods, chooserConfig);

      let primaryWallet = null;

      if (currency === "USD") {
        primaryWallet = wallets.find((wallet) =>
          wallet.tags.find((tag) => ["registration", "payout_allowed"].indexOf(tag.tag) >= 0) // "payout_allowed" is a MOD specific wallet tag
        );
      } else {
        primaryWallet = wallets.find((wallet) =>
          wallet.tags.find((tag) => tag.tag === "convertible")
        );

        // default to USD wallet if given currency wallet is not found
        if (!primaryWallet) {
          primaryWallet = wallets.find((wallet) =>
            wallet.tags.find((tag) => tag.tag === "registration")
          );
        }
      }

      setWallet(primaryWallet);
      setIsSuccess(true);
    }
  }, [isGetTransactionMethodsSuccess, setIsSuccess, data, currency]);

  return { wallet, isSuccess, ...rest };
};

export default useGetPrimaryWallet;
